/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppUsageReport } from '../../models/app-usage-report';

export interface AppUsagesControllerGetAppUsages$Params {
}

export function appUsagesControllerGetAppUsages(http: HttpClient, rootUrl: string, params?: AppUsagesControllerGetAppUsages$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppUsageReport>>> {
  const rb = new RequestBuilder(rootUrl, appUsagesControllerGetAppUsages.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AppUsageReport>>;
    })
  );
}

appUsagesControllerGetAppUsages.PATH = '/app-usages';
